"use client"
import { Users, BarChart3, TrendingUp, Zap, ArrowRight } from 'lucide-react';
import { useTheme } from '../utils/theme';

export function PlayerdevelopmentLanding({ onNavigate }) {
  const { theme } = useTheme();
  const isDarkMode = true; // OLED: always dark

  return (
    <div className={`min-h-screen transition-colors duration-200 ${'bg-[#0a0a0a] text-gray-100'}`}>
      <div className="mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8">
          <div
            onClick={() => onNavigate('athlete')}
            className={`group transition-colors duration-200 rounded-3xl p-8 cursor-pointer ${'bg-gray-800 border border-yellow-500/30 hover:border-yellow-500/50'}`}
          >
            <div className="flex items-start justify-between mb-6">
              <div className="p-4 bg-blue-500/20 rounded-2xl group-hover:scale-110 transition-transform">
                <Users className="text-blue-500" size={32} />
              </div>
              <ArrowRight className={`${'text-gray-400 group-hover:text-yellow-500'} transition-colors`} size={24} />
            </div>

            <h2 className="text-2xl font-bold mb-3">Athlete Performance</h2>
            <p className={`${'text-gray-400'} mb-6`}>
              Track individual athlete metrics, health data, and NIL earnings projections
            </p>

            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>Real-time performance tracking</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>Health & recovery metrics</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>NIL revenue projections</span>
              </div>
            </div>

            <div className={`mt-6 pt-6 ${'border-t border-yellow-500/30'}`}>
              <div className="flex items-center justify-between">
                <span className={`text-sm ${'text-gray-400'}`}>Example Athlete</span>
                <span className="text-sm font-semibold text-blue-500">Blake Barker</span>
              </div>
            </div>
          </div>
          <div
            onClick={() => onNavigate('coach')}
            className={`group transition-colors duration-200 rounded-3xl p-8 cursor-pointer ${'bg-gray-800 border border-yellow-500/30 hover:border-yellow-500/50'}`}
          >
            <div className="flex items-start justify-between mb-6">
              <div className="p-4 bg-purple-500/20 rounded-2xl group-hover:scale-110 transition-transform">
                <BarChart3 className="text-purple-500" size={32} />
              </div>
              <ArrowRight className={`${'text-gray-400 group-hover:text-yellow-500'} transition-colors`} size={24} />
            </div>

            <h2 className="text-2xl font-bold mb-3">Coach Dashboard</h2>
            <p className={`${'text-gray-400'} mb-6`}>
              Manage team performance, analyze trends, and optimize training programs
            </p>

            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>Team-wide analytics</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>Performance comparisons</span>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className={`${'text-gray-300'}`}>Training optimization</span>
              </div>
            </div>

            <div className={`mt-6 pt-6 ${'border-t border-yellow-500/30'}`}>
              <div className="flex items-center justify-between">
                <span className={`text-sm ${'text-gray-400'}`}>Team Overview</span>
                <span className="text-sm font-semibold text-purple-500">Virginia Baseball</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}